<template>
  <div class="wof" :class="{ 'wof--active' : wheelState}">
    <div class="wof__wrapper">

      <div class="wof__code-input-container" v-if="contestType === 'code'">
        <code-input v-show="!wheelState"></code-input>
      </div>

      <div class="wof__container">
        <div class="wof__indicator"></div>
        <div class="wof__image" v-bind:style="rotateStyle"
             :class="['wof__image--' + language,
             {'wof__image--shaking' : !animationStartet},
             {'wof__image--disabled' : animationStartet}]"
             v-on:click="spin">
          <lazy-image :src="'static/wheeloffortune_butterfly_' + language + '.png'" :src-small="'static/wheeloffortune_emmental_' + language + '_small.png'" :blur="false"></lazy-image>
        </div>
        <div v-if="!animationStartet"
             class="wof__center wof__center--active"
             v-on:click="spin"></div>
      </div>
    </div>

    <div class="wof__form-input-container" v-if="contestType === 'form' && !wheelState">
      <form-input v-show="!wheelState"></form-input>
    </div>

    <div class="wof__modal-container" v-if="showDefaultPriceModal">
      <div class="wof__winning-modal">
        <div class="container" v-if="!formSubmittedState">
          <h2 class="heading heading--2">{{ modalTitle }}</h2>
          <span class="price-preview__text" v-html="modalSubtitle"></span>
        </div>

        <div class="container" v-if="!formSubmittedState && priceType === 'default'">
          <form-price-default></form-price-default>
        </div>

        <div class="container" v-if="!formSubmittedState && priceType === 'basic'">
          <form-price-basic></form-price-basic>
        </div>

        <div class="container" v-if="!formSubmittedState && priceType === 'gift'">
          <form-price-gift></form-price-gift>
        </div>

        <div class="container" v-if="formSubmittedState || noSuccesScreen">
          <div v-if="!noSuccesScreen" class="price-preview__text" v-html="successText"></div>
          <button class="button button--secondary button--margin-top"
                  v-on:click="resetAll" v-html="buttonSuccessText"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CodeInput from './CodeInput'
import FormInput from './FormInput'
import FormPriceBasic from './FormPriceBasic'
import FormPriceDefault from './FormPriceDefault'
import FormPriceGift from './FormPriceGift'
import LazyImage from "./LazyImage";

export default {
  components: {
    LazyImage,
    CodeInput,
    FormInput,
    FormPriceBasic,
    FormPriceDefault,
    FormPriceGift
  },
  computed: {
    ...mapGetters([
      'contestType',
      'wheelState',
      'codeState',
      'animationFinished',
      'priceState',
      'priceType',
      'content',
      'formSubmittedState',
      'language',
      'rotateStyle',
      'animationStartet'
    ]),
    showDefaultPriceModal: function() {
      return this.animationFinished && this.price
    },
    price() {
      return this.$config.default.PRICE_MAP[this.priceState]
    },
    modalTitle() {
      let price = this.content.prices.find(price => price.key === this.priceState)
      return price.wonText
    },
    modalSubtitle() {
      return this.content.prices.find(price => price.key === this.priceState).wonSubtitle
    },
    successText() {
      return (this.priceType === 'default') ? this.content.formSuccess : this.content.formSuccessAlternate
    },
    buttonSuccessText() {
      return (this.priceType === 'default') ? this.content.tryAgain : this.content.close
    },
    noSuccesScreen() {
      return (this.priceType === 'blank' || this.priceType === 'instant')
    }
  },
  watch: {
    'wheelState': function (newVal) {
      if(newVal) {
        this.$nextTick(() => {
          const scrollPos = window.scrollY + this.$el.getBoundingClientRect().top - (window.innerHeight * 0.33)
          window.scrollTo({top: scrollPos, left: 0, behavior: 'smooth'})
        })
      }
    }
  },
  methods: {
    ...mapActions([
      'runWheelAnimation',
      'resetAll'
    ]),
    spin: function() {
      if(this.priceState) {
        let fullSpins = 1;
        if((Math.random() > 0.5)) fullSpins = 2;
        let deg = this.price.deg + fullSpins * 360;
        this.runWheelAnimation({duration: 2 * fullSpins, deg: deg});
      }
    }
  }
}
</script>
<style lang="scss">
.wof {
  position: relative;
  width: 100%;

  &--active {
    .wof__container {
      opacity: 1;
    }

    .wof__image {
      &--shaking {
        animation: shake 1.5s ease-in-out infinite;
      }
    }

    .wof__center {
      animation: pulse .75s ease-in-out 2;
      cursor: pointer;
      transition: .1s ease all;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }

  &__indicator {
    position: absolute;
    top: -25px;
    left: calc(50% - 15px);
    z-index: 10;
    width: 30px;
    height: 70px;
    background-image: url(../assets/wheeloffortune-indicator.png);
    background-size: contain;
    background-repeat: no-repeat;

    @media (min-width: 768px) {
      top: -35px;
      left: calc(50% - 22.5px);
      width: 55px;
      height: 103px;
    }
  }

  &__center {
    position: absolute;
    top: 40%;
    left: 40%;
    width: 20%;
    height: 20%;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    z-index: 100;

    &--FR {
      background-image: url(../assets/start-button_F.svg);
    }

    &--IT {
      background-image: url(../assets/start-button_I.svg);
    }

    &--EN {
      background-image: url(../assets/start-button_E.svg);
    }

    &--DE {
      background-image: url(../assets/start-button_D.svg);
    }

    &--active {
      background-image: url(../assets/wheeloffortune-center.svg);
      z-index: 10;
    }
  }

  &__container {
    position: relative;
    padding-bottom: 100%;
    opacity: .05;
  }

  &__form-input-container {
    margin-top: -325px;

    @media (min-width: 768px) {
      margin-top: 25px;
    }

    @media (min-width: 1280px) {
      margin-top: 0;
    }
  }

  &__modal-container {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    overflow-y: scroll;
    width: 100vw;
    height: 100vh;
    background-color: rgba(247, 247, 247, 0.75);
  }

  &__winning-modal {
    margin: 150px auto;
    width: 50%;
    height: auto;
    background-color: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08), 0 0 50px 0 rgba(0, 0, 0, 0.05);
    padding: 25px 0;

    @media (max-width: 1203px) {
      width: 75%;
    }

    @media (min-width: 768px) {
      padding: 45px;
    }

    .heading {
      text-align: left;
      margin-bottom: 19px;
    }

    .checkbox {
      align-items: inherit;

      @media (max-width: 768px) {
        margin-top: 25px;
      }

      &__container {
        margin-top: 4px;
      }

      &__label {
        font-size: 15px;
      }
    }
  }

  &__image {
    position: absolute;
    width: 100%;
    height: 100%;
    //   background-image: url(../assets/wheel.png);
    background-size: 100% 100%;

    cursor: pointer;

    &--disabled {
      cursor: default;
      pointer-events: none;
    }

    /*
                &--IT {
                    background-image: url(../assets/wheeloffortune_7_I.png);
                }

                &--FR {
                    background-image: url(../assets/wheeloffortune_7_F.png);
                }

                &--EN {
                    background-image: url(../assets/wheeloffortune_7_E.png);
                }

                &--DE {
                    background-image: url(../assets/wheeloffortune_111_D.png);
                } */
  }

  &__code-input-container {
    position: absolute;
    top: calc(50% - 66px);
    left: calc(50% - 145px);
    z-index: 100;
  }
}

.button--margin-top {
  margin-top: 25px;
}

.form__row {
  margin-top: 26px;

  @media (min-width: 768px) {
    .form__row--small {
      margin-top: 16px;
    }
  }
}

.form__submit {
  @media (max-width: 768px) {
    margin-top: 26px;
  }
  @media (min-width: 768px) {
    margin-left: 20px;
    width: calc(25% - 15px);
  }
  min-width: 160px;
  justify-content: flex-end;

  button, .button {
    width: 100%;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes shake {
  50% {
    transform: rotate(-.35deg);
  }
}

.checkbox__label.checkbox__label--legal {
  cursor: default;
  padding-left: 0;
}
</style>